module.exports = __webpack_public_path__ + "img/PTI_MEDICO.a468590d.png";